<template>
    <ul class="filters-preview">
        <li v-for="(filter, index) in activeFilters" :key="index" @click="editFilter(filter)">
            <CompassTagInteractive
                color="blue"
                :class="tagClass(filter)"
                :modelValue="filter.name"
                :keyLabel="filter.label"
                :valueLabel="$filters.shortText(filter.translation)"
                :maxWidth="true"
                @tag-remove="$store.dispatch(`${listinghash}/removeFilter`, filter)"
            />
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        listinghash: {
            type: String,
            required: true,
        },
    },
    computed: {
        activeFilters() {
            return this.$store.getters[`${this.listinghash}/activeFilters`];
        },
    },
    methods: {
        filterEditable(filter) {
            return !_.has(this.$store.state[this.listinghash].prefilter, filter.name);
        },
        editFilter(filter) {
            if (!this.filterEditable(filter)) {
                return false;
            }

            return this.$store.dispatch(`${this.listinghash}/editFilter`, filter);
        },
        tagClass(filter) {
            let classes = ['filters-preview__tag'];
            if (!this.filterEditable(filter) && !filter.deletable) {
                classes.push('filters-preview__tag--no-close');
            }
            return classes;
        },
    },
};
</script>

<style lang="scss" scoped>
.filters-preview {
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacing-1);
    list-style-type: none;
    margin: 0;
    padding: 2px 0 0;

    &__tag {
        cursor: pointer;

        &--no-close {
            &::v-deep {
                .compass-icon-button {
                    display: none;
                }
            }
        }
    }
}
</style>
